import { NgModule } from '@angular/core';
import { CheckboxModule } from 'primeng/checkbox';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormRowTemplate, FormRowComponent } from './components/form-components/form-row.component';
import { FormInputReadonlyComponent } from './components/form-fields/form-input-readonly.component';
import { FormInputTextComponent } from './components/form-fields/form-input-text.component';
import { FormInputTextareaComponent } from './components/form-fields/form-input-textarea.component';
import { FormButtonbarComponent } from './components/form-components/form-buttonbar.component';
import { FormConfirmButtonComponent } from './components/form-components/form-confirm-button.component';
import { FormCheckboxComponent } from './components/form-fields/form-checkbox.component';
import { FormSelectComponent } from './components/form-fields/form-select.component';
import { FormCalendarComponent } from './components/form-fields/form-calendar.component';
import { FormInputNumberComponent } from './components/form-fields/form-input-number.component';
import { FormMultiselectComponent } from './components/form-fields/form-multiselect.component';
import { FormInputSwitchComponent } from './components/form-fields/form-input-switch.component';
import { FormInputOptionalSwitchComponent } from './components/form-fields/form-input-optional-switch.component';
import { FormInputHhmmComponent } from './components/form-fields/form-input-hhmm.component';
import { FormButtongroupSelectionComponent } from './components/form-fields/form-buttongroup-selection.component';
import { FormRadiobuttonComponent } from './components/form-fields/form-radiobutton.component';
import { FormUploadComponent } from './components/form-fields/form-upload.component';
import { LabelValueComponent } from './components/form-components/label-value.component';
import { FileUtils } from './utils/file-utils';
import { FormInputPasswordComponent } from './components/form-fields/form-input-password.component';
import { ZoomableContainerComponent } from './components/zoomable-container/zoomable-container.component';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FormInputTextButtonComponent } from './components/form-fields/form-input-text-button.component';
import { VideoDialogComponent } from './components/video-dialog/video-dialog.component';
import { DialogModule } from 'primeng/dialog';
import { SafePipe } from './pipes/safe.pipe';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CheckboxModule,
    CalendarModule,
    InputSwitchModule,
    InputMaskModule,
    FormsModule,
    RadioButtonModule,
    KeyFilterModule,
    MessageModule,
    FileUploadModule,
    MultiSelectModule,
    ProgressSpinnerModule,
    DropdownModule,
    NgSelectModule,
    PaginatorModule,
    TooltipModule,
    TranslateModule,
    DialogModule
  ],
  declarations: [
    FormRowTemplate,
    FormRowComponent,
    FormInputReadonlyComponent,
    FormInputTextComponent,
    FormInputPasswordComponent,
    FormInputTextareaComponent,
    FormButtonbarComponent,
    FormConfirmButtonComponent,
    FormCheckboxComponent,
    FormSelectComponent,
    FormMultiselectComponent,
    FormCalendarComponent,
    FormInputNumberComponent,
    FormInputSwitchComponent,
    FormInputOptionalSwitchComponent,
    FormInputHhmmComponent,
    FormButtongroupSelectionComponent,
    FormRadiobuttonComponent,
    FormUploadComponent,
    LabelValueComponent,
    ZoomableContainerComponent,
    VideoDialogComponent,
    FormInputTextButtonComponent,
    SafePipe
  ],
  exports: [
    FormRowTemplate,
    FormRowComponent,
    FormInputReadonlyComponent,
    FormInputTextComponent,
    FormInputPasswordComponent,
    FormInputTextareaComponent,
    FormButtonbarComponent,
    FormConfirmButtonComponent,
    FormSelectComponent,
    FormMultiselectComponent,
    FormCheckboxComponent,
    FormCalendarComponent,
    FormInputNumberComponent,
    FormInputSwitchComponent,
    FormInputOptionalSwitchComponent,
    FormInputHhmmComponent,
    FormButtongroupSelectionComponent,
    FormRadiobuttonComponent,
    FormUploadComponent,
    LabelValueComponent,
    ZoomableContainerComponent,
    VideoDialogComponent,
    FormInputTextButtonComponent,
    SafePipe
  ],
  providers: [FileUtils, SafePipe]
})
export class SharedModule {
}